import { IPublishDestination } from 'src/components/PublishModal/types';
import { destinationId } from 'src/components/PublishModal/utilities/destinationId/destinationId';

export const SIBLING_INSTANCE_SELECTED = 'another instance of this connector is already selected';

/**
 * The publish handler dedupes venues per external system and silently drops later instances, so
 * only one instance per external system is selectable until AZ-8081 keys that on the instance.
 */
export const oneInstancePerExternalSystem = (
  publicationData: IPublishDestination[],
  destination: IPublishDestination,
  selectedIds: string[],
): string | undefined => {
  const selected = new Set(selectedIds);
  if (selected.has(destinationId(destination))) return undefined;

  const siblingSelected = publicationData.some(
    (other) =>
      other.channel_id === destination.channel_id &&
      destinationId(other) !== destinationId(destination) &&
      selected.has(destinationId(other)),
  );

  return siblingSelected ? SIBLING_INSTANCE_SELECTED : undefined;
};
